import React, { useEffect, useState } from "react";
import { api, apiError } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Checkbox } from "@/components/ui/checkbox";
import { ShieldCheck } from "lucide-react";
import { toast } from "sonner";
import { PersonFields, EMPTY_PERSON } from "./PersonFields";

export function RecipientConsentForm({ ship, pid, cfg, onSaved }) {
  const rd = ship.recipient_data || {};
  const [data, setData] = useState({ ...EMPTY_PERSON, ...rd });
  const [mode, setMode] = useState(rd.preferred_mode || "locker");
  const [point, setPoint] = useState(rd.pickup_point_ref || "");
  const [consent, setConsent] = useState(false);
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    if (ship.recipient_data) { return; }
    api.get(`/proposals/${pid}/delivery`).then((r) => {
      const m = r.data.mine;
      if (m) setData((d) => ({ ...d, name: m.recipient_name || "", address: m.address || "", cap: m.cap || "", city: m.city || "", province: m.province || "", phone: m.phone || "" }));
    }).catch(() => {});
  }, [pid, ship.recipient_data]);

  const save = async () => {
    setBusy(true);
    try { await api.put(`/shipping/${ship.id}/recipient-data`, { consent, data, preferred_mode: mode, pickup_point_ref: point }); toast.success("Dati confermati e condivisi con il mittente."); onSaved(); }
    catch (e) { toast.error(apiError(e)); } finally { setBusy(false); }
  };

  const modes = Object.entries(cfg.delivery_modes).filter(([k]) => k !== "home" || cfg.home_delivery_available);
  return (
    <div className="mt-3 rounded-xl border border-[#2DD4BF]/30 bg-[#2DD4BF]/5 p-3" data-testid="recipient-consent-form">
      <p className="flex items-center gap-2 text-sm font-semibold text-[#2DD4BF]"><ShieldCheck className="h-4 w-4" />{ship.recipient_consent_at ? "I tuoi dati per ricevere (condivisi)" : "Conferma i dati per ricevere il pacco"}</p>
      <p className="mt-1 text-xs text-[#94A3B8]">Saranno visibili solo a @{ship.sender_username} per preparare la spedizione. Per Locker e Point bastano nome, telefono o email e il punto di ritiro.</p>
      <div className="mt-3 flex flex-wrap gap-2">
        {modes.map(([k, l]) => <button key={k} type="button" onClick={() => setMode(k)} data-testid={`recipient-mode-${k}`} className={`rounded-lg border px-3 py-1.5 text-sm transition-colors ${mode === k ? "border-[#2DD4BF] bg-[#2DD4BF]/10 text-[#2DD4BF]" : "border-[#2A3655] text-[#CBD5E1]"}`}>{l}</button>)}
      </div>
      <div className="mt-3"><PersonFields value={data} onChange={setData} prefix="recipient" /></div>
      {mode !== "home" && (
        <div className="mt-2">
          <Label className="text-xs text-[#CBD5E1]">Codice o nome del Locker / Point scelto</Label>
          <Input value={point} onChange={(e) => setPoint(e.target.value)} placeholder="Scegli il punto sul sito InPost e incolla qui il riferimento" data-testid="recipient-point" className="bg-[#0B1020] border-[#2A3655]" />
          <a href={cfg.official_url} target="_blank" rel="noopener noreferrer" className="mt-1 inline-block text-xs text-[#2DD4BF] hover:underline" data-testid="recipient-find-point">Trova un punto sul sito InPost ↗</a>
        </div>
      )}
      <label className="mt-3 flex items-start gap-2 text-xs text-[#CBD5E1]">
        <Checkbox checked={consent} onCheckedChange={(v) => setConsent(!!v)} data-testid="recipient-consent-checkbox" className="mt-0.5" />
        Acconsento a condividere questi dati con @{ship.sender_username} solo per la spedizione di questo scambio.
      </label>
      <Button onClick={save} disabled={busy || !consent} data-testid="recipient-consent-save" className="mt-3 bg-[#10B981] hover:bg-[#0e9e6e]">Conferma e condividi</Button>
    </div>
  );
}
